import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FaArrowCircleRight } from 'react-icons/fa';
import { Field, Form } from 'react-final-form';

import { AuthContext } from './AuthContext';

export const LoginForm = withRouter((props) => {
    const { setAuth } = useContext(AuthContext);
    const { url } = props.match.params;
    const { emailBasedAuthentication } = props;

    return (
        <div className="sm:max-w-xl max-w-sm mx-auto bg-white w-full rounded shadow-md">
            <div className="max-w-lg mx-auto w-4/5 md:py-4 md:w-3/5 md:text-center">
                <div className="w-full text-sm md:text-xl pt-2 md:pb-2 font-semibold text-blue-700 leading-relaxed">
                    {emailBasedAuthentication
                        ? 'Enter registered email address to login'
                        : 'Enter code to login'}
                </div>

                <div>
                    <Form
                        onSubmit={(values) =>
                            new Promise((resolve, reject) => {
                                props
                                    .authenticateLink(url, values, setAuth)
                                    .then((res) => {
                                        // letting form know that submit was successful.
                                        resolve({});
                                    })
                                    .catch((error) => {
                                        // return the error.
                                        resolve({
                                            message:
                                                error?.response?.status === 401
                                                    ? emailBasedAuthentication
                                                        ? 'Email address does not match our records'
                                                        : 'Invalid passcode'
                                                    : 'Something went wrong',
                                        });
                                    });
                            })
                        }
                        render={(formState) => {
                            const { handleSubmit, submitErrors } = formState;
                            return (
                                <form>
                                    <div className="md:flex md:items-center mt-2 md:mt-6">
                                        <div className="w-full mb-2 md:mb-0 md:w-1/3">
                                            <label className="block text-xs md:text-l text-gray-700 font-bold md:text-right mb-1 md:mb-0 pr-4">
                                                {emailBasedAuthentication
                                                    ? 'Login Email Address:'
                                                    : 'Login Code:'}
                                            </label>
                                        </div>
                                        <div className="md:w-2/3">
                                            <Field
                                                name={
                                                    emailBasedAuthentication
                                                        ? 'email'
                                                        : 'passcode'
                                                }
                                                // using "render" in place of "component" to force Chrome/browsers not to treat the entered 6-digit login codes as passwords,
                                                // preventing this to compare against its repository of breached passwords which otherwise results in a browser warning
                                                render={({ input }) => (
                                                    <input
                                                        {...input}
                                                        id="otp"
                                                        className="appearance-none rounded w-full py-1 md:py-2 px-4 text-gray-700 leading-tight border border-gray-400 bg-gray-200 focus:bg-white focus:outline-none focus:border-blue-500 shadow-inner shadow-xl"
                                                        type={
                                                            emailBasedAuthentication
                                                                ? 'email'
                                                                : 'password'
                                                        }
                                                        data-testid={
                                                            emailBasedAuthentication
                                                                ? 'email'
                                                                : 'passcode'
                                                        }
                                                    />
                                                )}
                                            />
                                            {submitErrors && (
                                                <span className="block text-xs italic w-full text-red-700">
                                                    {submitErrors.message}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <button
                                            type="submit"
                                            className="overflow-hidden bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 md:py-2 px-3 md:px-6 my-4 md:my-6 rounded focus:outline-none"
                                            onClick={handleSubmit}
                                        >
                                            {' Login'}
                                            <span className="text-base z-1 align-middle ml-2 inline-block">
                                                <FaArrowCircleRight />
                                            </span>
                                        </button>
                                    </div>
                                    {/* <pre>{JSON.stringify(values, undefined, 2)}</pre> */}
                                </form>
                            );
                        }}
                    />
                </div>
            </div>
        </div>
    );
});

LoginForm.propTypes = {
    authenticateLink: PropTypes.func,
    emailBasedAuthentication: PropTypes.bool,
};
